import "./css/output.css";
export default function LongTextValue({ label, value, className, ...props }) {
  const computedClassName = [
    "output",
    "long-text-value",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && <strong>{label}</strong>}
      <br />
      <span>{value}</span>
    </div>
  );
}

LongTextValue.defaultProps = {
  className: "",
};
